export const NAME = 'edit-template-view';
export const SIDE_WIDTH = 140;
export const LANGUAGE_DICTIONARY = {
    'es-mx': { key: 'es-mx', label: 'Spanish' },
};
